import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import s from '../Menu/Menu.module.scss';
import Header from '../../components/Header/Header';
import Loader from '../../components/Loader/Loader';
import api from '../../api/index.js';
import cs from './Characteristics.module.scss';

const CharacteristicsHub = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const [st, cats] = await Promise.all([
        api.characteristics.getStats(),
        api.categories.getAllMaster(),
      ]);
      if (!st.error) setStats(st);
      if (!cats.error && cats.categories?.length) {
        setCategories(
          cats.categories.map((c) => ({ id: c._id, title: c.category_name })),
        );
      }
      setLoading(false);
    })();
  }, []);

  return (
    <>
      <Header
        title="Настройка характеристик"
        breadCrumbs={[
          { name: 'Главная', link: '/' },
          { name: 'Характеристики', link: '/characteristics' },
        ]}
      />
      {loading && <Loader />}
      {!loading && (
        <div className={cs.wrap}>
          <p className={cs.lead}>
            Приведение полей от поставщиков к единому виду: что настроено, что ещё нет.
            Bitrix и выгрузка — следующий шаг, здесь только правила mapping.
          </p>
          {stats && (
            <div className={cs.cards}>
              <div className={`${cs.card} ${cs.cardGreen}`}>
                <div className={cs.cardNum}>{stats.ready_for_export || 0}</div>
                <div className={cs.cardLabel}>готовы к выгрузке</div>
              </div>
              <div className={`${cs.card} ${cs.cardYellow}`}>
                <div className={cs.cardNum}>{stats.needs_attention || 0}</div>
                <div className={cs.cardLabel}>нужно проверить</div>
              </div>
            </div>
          )}
          <div className={cs.catGrid}>
            {categories.map((item) => (
              <div
                key={item.id}
                className={s.item}
                onClick={() => navigate(`/characteristics/categories/${item.id}`)}
              >
                <h3>{item.title}</h3>
                <button
                  className="btn grey"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/characteristics/categories/${item.id}`);
                  }}
                >
                  Открыть
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CharacteristicsHub;
